<fin-editorial-page-head [title]="(activeNaviSection$ | async)?.teaserTitle" [titleAsHeading]="!titleAsSpan()" />

<section class="editorial-main mr-medium-y grid-max-width padding-left-gutter padding-right-gutter center">
  <div class="grid-col-12 grid-max-width no-row-gap white-bg surface-primary relative rounded-large">
    <!-- Section navigation -->
    <fin-section-navi class="col-1-12 md-col-1-3 sm-col-2-11 mr-xlarge-t" [nested]="true" />

    <!-- FAQ content -->
    <section class="col-1-12 md-col-4-12 sm-col-2-11 mr-medium-t mr-large-b">
      @if (hasContent) {
        <fin-cms-json-content @fadeIn class="grid-col-12 no-gutters no-row-gap" [template$]="template$" />
      } @else {
        <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" />
      }
    </section>
  </div>
</section>
